var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31 28c.28 0-1.33.56 24.72-9.12a1 1 0 0 0 .59-1.29A27.11 27.11 0 0 0 31 0a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1zm1-26a25.12 25.12 0 0 1 22.07 15.36L32 25.56z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 33a26.87 26.87 0 0 0-1.68-9.44A1 1 0 0 0 51 23l-23 8.56V7a1 1 0 0 0-1-1 27 27 0 1 0 10.4 51.91c6.849 3.937 15.577 1.887 19.957-4.687S60.27 37.805 54 33zM26 8v23.74L2.93 26.31A24.87 24.87 0 0 1 26 8zM2.46 28.26l23.24 5.46L18 56.28C6.729 51.923.187 40.128 2.46 28.26zm17.39 28.67 7.94-23.16 23-8.54A24.53 24.53 0 0 1 52 31.72c-6.8-3.594-15.215-1.464-19.485 4.933-4.27 6.396-3.011 14.985 2.915 19.887a24.8 24.8 0 0 1-15.58.39zM45 58c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13a13 13 0 0 1-13 13z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.71 38.29a1 1 0 0 0-1.42 0l-12 12A1 1 0 0 0 39 52a1 1 0 0 0 .71-.29l12-12a1 1 0 0 0 0-1.42zM43 40a3 3 0 1 0-6 0 3 3 0 0 0 6 0zm-4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM50 47a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.3a188c5de1d713baabffa52b61159f8f.svg";
export { ForwardRef as ReactComponent };